import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from './firebaseConfig';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import NewProjectModal from './NewProjectModal';

function Home({ userRole }) {
  const [projects, setProjects] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filtro, setFiltro] = useState('Todos');
  const [busca, setBusca] = useState('');

  useEffect(() => {
    const q = query(collection(db, "projects"), orderBy("createdAt", "desc"));
    return onSnapshot(q, (snapshot) => {
      setProjects(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
  }, []);

  const hojeStr = new Date().toISOString().split('T')[0];

  const calcularDiasRestantes = (deadline) => {
    if (!deadline) return null;
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const [ano, mes, dia] = deadline.split('-');
    const dataFim = new Date(ano, mes - 1, dia);
    dataFim.setHours(0, 0, 0, 0);
    const diffTime = dataFim - hoje;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  const projetosFiltrados = projects
    .filter(p => p.name.toLowerCase().includes(busca.toLowerCase()))
    .filter(p => {
      if (filtro === 'Todos') return true;
      return p.status === filtro;
    });

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <header className="mb-10">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">Controle de Sistemas</h1>
        <div className="flex flex-wrap items-center gap-2 mb-6">
          {/* CORREÇÃO: Adicionado 'Estudo de Projeto' aos filtros */}
          {['Todos', 'Estudo de Projeto', 'Em desenvolvimento', 'Homologação', 'Produção', 'Finalizado'].map(f => (
            <button key={f} onClick={() => setFiltro(f)} className={`px-4 py-2 rounded-full font-bold text-sm transition ${filtro === f ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 border'}`}>{f}</button>
          ))}
          <div className="ml-auto flex gap-2">
            {userRole === 'admin' && <Link to="/users" className="bg-teal-600 text-white px-4 py-2 rounded font-bold hover:bg-teal-700 shadow-md">Gerenciar Usuários</Link>}
            <Link to="/timeline" className="bg-purple-600 text-white px-4 py-2 rounded font-bold hover:bg-purple-700 shadow-md">Timeline</Link>
            <Link to="/relatorios" className="bg-gray-600 text-white px-4 py-2 rounded font-bold hover:bg-gray-700 shadow-md">Relatórios</Link>
            {userRole === 'admin' && <button onClick={() => setIsModalOpen(true)} className="bg-blue-600 text-white px-4 py-2 rounded font-bold hover:bg-blue-700 shadow-md">+ Novo Projeto</button>}
          </div>
        </div>
        <input className="border p-2 rounded shadow-sm w-full md:w-64" placeholder="Buscar projeto por nome..." onChange={(e) => setBusca(e.target.value)} value={busca} />
      </header>

      <div className="mb-8">
        <h2 className="text-lg font-bold text-red-600 mb-2">⚠️ Projetos com Prazo Expirado:</h2>
        <div className="flex gap-4 overflow-x-auto pb-2">
          {projects.filter(p => p.deadline && p.deadline < hojeStr && p.status !== 'Produção' && p.status !== 'Finalizado').length === 0 ? <p className="text-sm text-gray-500 italic">Nenhum projeto atrasado.</p> : projects.filter(p => p.deadline && p.deadline < hojeStr && p.status !== 'Produção' && p.status !== 'Finalizado').map(p => (
            <div key={p.id} className="bg-red-50 border border-red-200 p-4 rounded min-w-[200px] text-xs text-red-800 font-bold shadow-sm">{p.name}<br/><span className="font-normal">Venceu em: {new Date(p.deadline + 'T00:00:00').toLocaleDateString('pt-BR')}</span></div>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {projetosFiltrados.map((proj) => {
          const diasRestantes = calcularDiasRestantes(proj.deadline);
          const projetoAtivo = proj.status !== 'Produção' && proj.status !== 'Finalizado';

          return (
            <Link key={proj.id} to={`/projeto/${proj.id}`} className={`bg-white p-6 rounded-lg shadow-md border-t-4 transition hover:shadow-xl flex flex-col h-full ${proj.deadline && proj.deadline < hojeStr && projetoAtivo ? 'border-red-500' : 'border-blue-500'}`}>
              <h3 className="text-xl font-bold text-gray-900">{proj.name}</h3>
              <div className="flex justify-between items-center border-b pb-2 mb-3 mt-1">
                <p className="text-gray-500 text-xs">Solicitante: {proj.requester || 'N/A'}</p>
                <span className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded" title="Total de versões">🗂️ {proj.versionCount || 0}</span>
              </div>
              <p className="text-sm text-gray-600 flex-grow mb-4 line-clamp-3">{proj.description || <span className="italic">Sem descrição.</span>}</p>
              <div className="mt-auto">
                <div className="flex flex-wrap gap-2 mb-4">{proj.checklist?.map(item => <span key={item} className="bg-blue-50 text-blue-800 text-[10px] px-2 py-1 rounded uppercase">{item}</span>)}</div>
                <div className="pt-4 border-t flex justify-between items-center">
                  <div>
                    {projetoAtivo && diasRestantes !== null && (
                      diasRestantes < 0 ? <span className="text-[10px] font-bold bg-red-100 text-red-700 px-2 py-1 rounded">ATRASADO {Math.abs(diasRestantes)} DIAS</span>
                      : diasRestantes === 0 ? <span className="text-[10px] font-bold bg-orange-100 text-orange-700 px-2 py-1 rounded">VENCE HOJE!</span>
                      : diasRestantes <= 5 ? <span className="text-[10px] font-bold bg-yellow-100 text-yellow-700 px-2 py-1 rounded">FALTAM {diasRestantes} DIAS</span>
                      : <span className="text-[10px] font-bold bg-gray-100 text-gray-600 px-2 py-1 rounded">Faltam {diasRestantes} dias</span>
                    )}
                  </div>
                  {/* CORREÇÃO: Nova cor para 'Estudo de Projeto' */}
                  <span className={`text-[10px] font-bold px-2 py-1 rounded-full uppercase ${
                    proj.status === 'Produção' ? 'bg-green-100 text-green-800' :
                    proj.status === 'Homologação' ? 'bg-blue-100 text-blue-800' :
                    proj.status === 'Finalizado' ? 'bg-gray-200 text-gray-600' :
                    proj.status === 'Estudo de Projeto' ? 'bg-purple-100 text-purple-800' : // <-- NOVIDADE
                    'bg-yellow-100 text-yellow-800' // 'Em desenvolvimento'
                  }`}>{proj.status}</span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
      {isModalOpen && <NewProjectModal onClose={() => setIsModalOpen(false)} onSave={() => setIsModalOpen(false)} />}
    </div>
  );
}
export default Home;